import React from "react"

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";


const Loader = (props) => {
    const {isLoading, children, size=40, sx} = props;

    return <>
        {
            isLoading ?
                <Box sx={{width: '100%', textAlign: "center", ...sx}}>
                    <CircularProgress color="primary" size={size}/>
                </Box>
                :
                children
        }

    </>
}

export default Loader;